import { TableLandingBorrowContainer } from "../../containers/borrowSystem/TableLandingBorrowContainer";

export function TableLandingBorrowPage() {
    return (
        <TableLandingBorrowContainer />
    )
}